/**
 * Builds an empty row for the grid.
 *
 * All cells start at their empty_value — defaults are not seeded into the row.
 * Defaults for any blank field are applied at the calculation layer via
 * effectiveValue (in getFormatControlledValue) and at the server layer via
 * FieldsMap::Defaults.
 *
 * For text and date columns, empty_value is { value: "" } (object).
 * For single-select columns, empty_value is null.
 *
 * @param {Array} columns - array of column definition objects
 * @returns {Object} a new row keyed by column.field
 */
export const buildEmptyRow = (columns) => {
  const row = {};
  columns.forEach((column) => {
    row[column.field] = column.empty_value;
  });
  return row;
};

/**
 * Builds the combination (pinned) row. Combo-capable single-select and text
 * columns hold arrays of { value } there; every other column starts at its
 * empty_value. Truthy values in `initial` win.
 *
 * @param {Array} columns - array of column definition objects
 * @param {Object} initial - stored pinned-row values keyed by column.field
 * @returns {Object} a new pinned row keyed by column.field
 */
export const buildEmptyPinnedRow = (columns, initial = {}) => {
  const row = {};
  columns.forEach((column) => {
    const defaultValue = (column.column_type === 'single_select' || column.column_type === 'text') ? [] : column.empty_value;
    row[column.field] = initial[column.field] || defaultValue;
  });
  return row;
};
